import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2026 Crown Management. All Rights Reserved.</p>
        <p className="made-with">
          Dibuat oleh ❤️ WILLY_007
          <a 
            href="https://wa.me/6287710528400" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            <i className="fab fa-whatsapp"></i> WILLY_007
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
